import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/AuthContext'
import { shiftReportService } from '@/services/shiftReportService'
import type { ShiftReportMe } from '@/types/shiftReports'

/**
 * Shift Reports add-on access, from GET /api/shift-reports/me. The nav entry shows
 * only when the store has it on AND the user can file (position has a set) or is an
 * admin. With the add-on off it shows for no one.
 */
export function useShiftReportsAccess() {
  const { user } = useAuth()
  // Keyed by user + active store: the store switcher changes both the toggle and the set.
  const query = useQuery<ShiftReportMe>({
    queryKey: ['shiftReportsMe', user?._id ?? null, user?.store?._id ?? null, user?.position ?? null],
    queryFn: shiftReportService.getMe,
    enabled: !!user,
    staleTime: 5 * 60 * 1000,
    retry: false
  })
  const me = query.data
  const showNav = !!me?.enabled && (!!me.eligible || !!me.isAdmin)
  return { me, showNav, isLoading: query.isLoading && !!user, isError: query.isError }
}
